/**
 * ViewSwitcher Component - Optimized view switching without rerenders
 * This component handles the view logic and prevents unnecessary rerenders
 */

import { type FC, memo } from 'react';
import { useSections } from 'store/app/appStore';
import MultiViewLobby from '../../../../layouts/Lobby/MultiViewLobby';
import SingleViewLobby from '../../../../layouts/Lobby/SingleViewLobby';

interface ViewSwitcherProps {
  showTournamentNavigation?: boolean;
  campaingOnlyView?: boolean;
}

const ViewSwitcher: FC<ViewSwitcherProps> = ({ showTournamentNavigation, campaingOnlyView }) => {
  const { viewMode } = useSections();

  // Keep both views mounted; toggle visibility with lightweight wrappers.
  return (
    <>
      <MultiViewLobby hidden={viewMode === 'single'} />
      <SingleViewLobby hidden={viewMode === 'multi'} showTournamentNavigation={showTournamentNavigation} campaingOnlyView={campaingOnlyView}/>
    </>
  );
};

// Memoize aggressively - this component should almost never rerender
export default memo(ViewSwitcher, (prevProps, nextProps) => {
  return prevProps.showTournamentNavigation === nextProps.showTournamentNavigation &&
    prevProps.campaingOnlyView === nextProps.campaingOnlyView
});
